import { appConfig } from '../config/app-config'

export function resolveApiAssetUrl(
  path: string | null,
  options: Readonly<{ normalizeLegacyImagePath?: boolean }> = {},
): string | null {
  if (!path) return null
  if (/^https?:\/\//i.test(path)) return path

  const normalizedPath = `/${path.replace(/^\/+/, '')}`
  const publicPath =
    options.normalizeLegacyImagePath && normalizedPath.startsWith('/images/')
      ? `/storage${normalizedPath}`
      : normalizedPath

  if (
    appConfig.apiBaseUrl.startsWith('/') &&
    publicPath.startsWith(`${appConfig.apiBaseUrl}/`)
  ) {
    return publicPath
  }

  return `${appConfig.apiBaseUrl}${publicPath}`
}

export function resolveUserMediaUrl(path: string | null): string | null {
  if (!path) return null
  if (/^https?:\/\//i.test(path)) return path
  const normalizedPath = `/${path.replace(/^\/+/, '')}`
  if (!normalizedPath.startsWith('/audio/')) return resolveApiAssetUrl(path)
  return `${appConfig.mediaPublicBaseUrl}${normalizedPath}`
}
